export default __webpack_public_path__ + "static/milk-d88708898af6cd20ba2efc6a7fb951fb.webp";